export enum FinancialsTableGroupBy {
  Role = 'ROLES_AND_TEAM_MEMBERS',
  Phase = 'PHASES_AND_TASKS',
}

export enum FinancialsZoomLevel {
  Overall = 'OVERALL',
  Quarterly = 'QUARTER',
  Monthly = 'MONTH',
  Period = 'PERIOD',
  Revenue = 'REVENUE',
  Profitability = 'PROFITABILITY',
}

export enum FinancialsComponentGroup {
  Budget = 'BUDGET',
  Hours = 'HOURS',
}

export enum FinancialsComponentType {
  BudgetLine = 'BUDGET_LINE',
  HoursLine = 'HOURS_LINE',
  BudgetBar = 'BUDGET_BAR',
  HoursBar = 'HOURS_BAR',
  BudgetTable = 'BUDGET_TABLE',
  HoursTable = 'HOURS_TABLE',
}

export interface FinancialsGroupByRendererParams {
  componentGroup: FinancialsComponentGroup;
  options: FinancialsTableGroupBy[];
  selectedOption: FinancialsTableGroupBy;
  onGroupByChange: (value: FinancialsTableGroupBy) => void;
}

export interface FinancialsZoomLevelSwitcherParams {
  type: FinancialsComponentType;
  tabs: FinancialsZoomLevel[];
  activeTab: FinancialsZoomLevel;
  onTabSwitch: (value: FinancialsZoomLevel) => void;
}

export interface FinancialsBudgetBase {
  revenue?: number;
  cost?: number;
  margin?: number;
  profit?: number;
}

export interface FinancialsHoursBase {
  timeTracked?: number;
  timeAllocated?: number;
  billableTimeTracked?: number;
  nonBillableTimeTracked?: number;
}

export interface FinancialsStyleProps {
  flexStyle?: number | string;
  backgroundColorStyle?: string;
  gapStyle?: string;
  paddingStyle?: string;
  widthStyle?: string;
  heightStyle?: string;
  minHeightStyle?: string;
  maxWidthStyle?: string;
  reverse?: boolean;
  hideShadow?: boolean;
  showBorder?: boolean;
}
